export default __webpack_public_path__ + "static/media/support-notes-main-economista.80173d85.png";